import React from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, useTheme} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react";
import {useStores} from "../../../../../hooks";
import {BookingFormType} from "../../../store/booking/forms";
import {localize} from "../../../../../common/libs";
import {SnackbarType} from "../../../../../stores/common";
import style from "./../style.module.css";

const DeleteMenuCategoryForm = () => {
    const {t} = useTranslation(["general", "menu"]);
    const { bookingStore, generalStore } = useStores();
    const forms = bookingStore.forms;
    const { open, current } = forms.forms[BookingFormType.deleteBookingCategory];
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));

    if (!current) return null;

    const submitDelete = async (e: React.MouseEvent) => {

        e.preventDefault();
        e.stopPropagation();

        if(!current) return;

       await bookingStore.removeCategory(current.menuId, current.id);
       generalStore.showSnackbar({
           title: t("menu:menuEditor.categorySuccessfullyDeleted"),
           type: SnackbarType.success
       });
        bookingStore.forms.closeForm(BookingFormType.deleteBookingCategory);
    }





    return (
        <Dialog
            open={open}
            onClose={() => {
                bookingStore.forms.closeForm(BookingFormType.deleteBookingCategory)
            }}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title" className={style.deleteContent}>
                {t("menu:deleteMenuCategory")}
            </DialogTitle>
            <DialogContent className={style.deleteContent}>
                {t("menu:youGoingRemoveMenuCategory")} '{localize(current.data.name)}'.
                <br/>
                {t("menu:itIsUndone")}

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={(e: React.MouseEvent) => {
                        e.preventDefault();
                        e.stopPropagation();
                        bookingStore.forms.closeForm(BookingFormType.deleteBookingCategory)
                    }}
                    color="primary">
                    {t("general:cancel")}
                </Button>
                <Button
                    color="default"
                    onClick={submitDelete}
                >
                    {t("menu:modifiersSet.wantDelete")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default observer(DeleteMenuCategoryForm);


